import { useSetAtom } from 'jotai';
import { useMemo } from 'react';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { useTwilioConversationCallbacks } from '../../session/chat/useTwilioConversationCallbacks';
import { ProviderDrawerState, sessionConversationSidAtom } from '../state';
import { useShowNewMessageToastCallback } from './useShowNewMessageToastCallback';

export function useSessionConversationCallbacks() {
  const { joinConversation, leaveConversation } = useTwilioConversationCallbacks();
  const setSessionConversationSid = useSetAtom(sessionConversationSidAtom);
  const showNewMessageToast = useShowNewMessageToastCallback();
  const getSessionConversationSid = useAtomCallbackMemoized((get) => get(sessionConversationSidAtom), []);

  return useMemo(
    () => ({
      joinSessionConversation: async (sessionConversationSid: string) => {
        const conversationResult = await joinConversation(sessionConversationSid, {
          onMessageAdded: (message) => {
            showNewMessageToast(message, ProviderDrawerState.SESSION_CHAT);
          },
        });
        if (conversationResult.status === 'success') {
          setSessionConversationSid(sessionConversationSid);
        }
        return conversationResult;
      },
      leaveSessionConversation: async (sessionConversationSidOverride?: string) => {
        const sessionConversationSid = sessionConversationSidOverride ?? getSessionConversationSid();
        if (!sessionConversationSid) return;
        const conversationResult = await leaveConversation(sessionConversationSid);
        if (conversationResult.status === 'success') {
          setSessionConversationSid(undefined);
        }
        return conversationResult;
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
